import React from "react";
import styles from "./indector.module.scss";

export const Indicator = () => {
  return (
    <div className={styles.indector_wrapper}>
      <ul>
        <li>
          <span>Australia</span>
          <button>x</button>
        </li>
        <li>
          <span>Melbourne</span>
          <button>x</button>
        </li>
        <li>
          <span>$4.5-$40</span>
          <button>x</button>
        </li>
        <li>
          <span>Australia</span>
          <button>x</button>
        </li>
        <li>
          <span>Melbourne</span>
          <button>x</button>
        </li>
        <li>
          <span>$4.5-$40</span>
          <button>x</button>
        </li>
      </ul>
    </div>
  );
};

export default Indicator;
